export enum PaymentMethod {
    CASH = "cash",
    BANK = "bank",
}

export enum PaymentKind {
    PaymentIn = "in",
    PaymentOut = "out",
}

export enum PackageUnit {
    DAY = "DAY",
    MONTH = "MONTH",
    YEAR = "YEAR",
}

export enum PackageType {
    TRIAL = 1,
    FEE = 2,
    FREE = 3,
}